<div class="report-view" *ngIf="partitions && simulations">
    <aside class="side-block">
        <h2>
            {{'reports.custom.tree.shortLabel' | translate}}
            <app-tooltip text="{{'reports.custom.tree.summary' | translate}}"></app-tooltip>
        </h2>
        <app-partitions-tree class="tree" id="tree-block"
            [isMultiple]="true" [partitions]="partitions"
            (toggleSelection)="onSelectPartition($event)"></app-partitions-tree>
    </aside>
    <section class="main-block" *ngIf="customReport.partitionsCodes && customReport.partitionsCodes.length">
        <div *ngFor="let reportItem of customReport.reportItems; index as i" id="custom-{{ reportItem.group }}-{{i}}">
            <ng-container *ngIf="!reportItem.variations.length">
                <h2>
                    {{'partitions.sunburst.title.shortLabel' | translate}} (<span class="year">{{ referenceYear }}</span>)
                    <app-tooltip data-html2canvas-ignore [text]="'partitions.sunburst.title.summary' | translate"></app-tooltip>
                </h2>
                <app-partitions-sunburst class="sunburst"
                    [isGrey]="true"
                    [mainPartition]="rootPartition"
                    [selectedCodes]="customReport.partitionsCodes"
                    [year]="referenceYear">
                </app-partitions-sunburst>
            </ng-container>

            <app-report-variation-select *ngIf="reportItem.variations.length" [reportItem]="reportItem"></app-report-variation-select>
        </div>
    </section>
</div>
<mat-progress-bar *ngIf="!simulations" class="progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
